import { Singleton } from "util";
import { RuntimePersistence } from "core/persistence";
import uuid4 from "uuid/v4";

@Singleton
class RuntimeRepository {
  static props = {
    currentUser: "currentUser",
    sidebarOpen: "sidebarOpen",
    redirectTarget: "redirectTarget",
    token: "token",
    sync: "sync",
    notification: "notification",
    supportVisible: "supportVisible",
    logoutByInactivity: "logoutByInactivity"
  };

  subscriptions = {};

  async tearUp() {
    this.runtimePersistence = await RuntimePersistence.getInstance();
  }

  async set(property, value) {
    this.runtimePersistence.set(property, value);
    this.fire(property, value);
  }

  async fire(property, value) {
    if (property in this.subscriptions) {
      Object.values(this.subscriptions[property]).forEach(subscription =>
        subscription(value)
      );
    }
  }

  async get(property) {
    return this.runtimePersistence.get(property);
  }

  async unset(property) {
    return this.runtimePersistence.unset(property);
  }

  subscribe(property, callback) {
    if (!(property in this.subscriptions)) {
      this.subscriptions[property] = {};
    }

    const key = uuid4();
    this.subscriptions[property][key] = callback;
    return key;
  }

  unsubscribe(property, subscriptionKey) {
    if (property in this.subscriptions) {
      delete this.subscriptions[property][subscriptionKey];
    }
  }
}

export default RuntimeRepository;



// WEBPACK FOOTER //
// ./src/core/repository/runtime.repository.js